// extracted by mini-css-extract-plugin
export var borderRadius = "_52-4";
export var large = "_52-3";
export var logoContainer = "_52-0";
export var nameLogo = "_52-2";
export var small = "_52-1";